exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".material-icons.action-icon[data-v-2a1a6b6e]{font-size:24px;margin:.25rem;color:silver}.material-icons.action-icon[data-v-2a1a6b6e]:hover{color:#e74c3c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2a1a6b6e&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/DeleteCategory.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2a1a6b6e&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/DeleteCategory.vue
// module chunks = 0